<template>
    <b-modal size="md" button-size="sm" v-model="showModal" :title="prefix + title" hide-footer @hidden="cancelar">
        <b-card bg-variant="light">
            <b-form @submit.prevent="save">
                <b-row>
                        <lg-form-date  :disabled="isVisualizacao" invalidFeedback="A data deve ser informada!" description=""
                            v-model="dataAgendamentoRetirada" typeDatepicker="date" label="Data de Retirada:" sm="4"
                             />

                </b-row>
                <b-row>
                    <lg-finder-page-pessoa :disabled="isVisualizacao" id="finderUsuarioAgendamento" @onselect="usuarioSelect"
                        invalidFeedback="Usuário deve ser informado!" :prefix="prefix + title + ' > '" description=""
                        v-model="codPessoaAgendamentoRetirada" label="Responsável:">
                    </lg-finder-page-pessoa>
                </b-row>
            </b-form>

            <div class="d-flex justify-content-center mt-3">
                <b-button id="confirmarSalvar" @click="save" variant="success" style="height: 30px" pill size="sm">
                    <div>
                        <b-icon icon="check-circle" />
                    </div>
                </b-button>
                <b-button id="cancelarSalvar" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div>
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>

        </b-card>

    </b-modal>
</template>

<script>
import { ListResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";

export default {
    components: {
        LgFormDate,
        LgFinderPagePessoa
    },
    props: {
        tarefa: Object,
        isVisualizacao: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Agendamento"
        }
    },
    data() {
        return {
            showModal: true,
            dataAgendamentoRetirada: '',
            codPessoaAgendamentoRetirada: {}
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    async beforeMount() {
        
        this.$service = new ResourceService(`/api/tarefa-solmovibp`);
        console.log(this.tarefa);
        this.dataAgendamentoRetirada = this.tarefa.dataAgendamentoRetirada;
        this.codPessoaAgendamentoRetirada = this.tarefa.codPessoaAgendamentoRetirada
    },
    methods: {
        usuarioSelect(pessoa){
            this.codPessoaAgendamentoRetirada = pessoa;

        },
        async save() {


            try {
                this.busy = true;

                await this.$service.put("save-agendamento/" + this.id, { dataAgendamentoRetirada: this.dataAgendamentoRetirada, codPessoaAgendamentoRetirada:this.codPessoaAgendamentoRetirada });

            }
            finally {

                this.cancelar();
            }

        },
        cancelar() {
            this.$emit("close");
        },
    },
};
</script>